import './icons/fontAwesome';
import './scss/statistics.scss';

import 'bootstrap';
import './shared';

import {SnippetProcessor} from '@/naja/SnippetProcessor';
import Chart from 'chart.js/auto';
import naja from 'naja';

import LineChartControl from '@/components/common/LineChartControl.vue';
import {VueComponentInitializer} from '@/components/initializers';
import PlaceMap from '@/components/statistics/PlaceMap.vue';
import PriceMap from '@/components/statistics/priceMap/PriceMap.vue';
import SearchBox from '@/components/statistics/SearchBox.vue';
import {initializeSentry} from '@/shared/sentry';
import {translationsFromAttribute} from '@/shared/translations';
// @ts-ignore
import netteForms from '../../vendor/nette/forms/src/assets/netteForms';

initializeSentry();

naja.formsHandler.netteForms = netteForms;
naja.registerExtension(SnippetProcessor, (snippet: HTMLElement) => {
    [
        new VueComponentInitializer('.vue-place-map', PlaceMap),
        new VueComponentInitializer('.vue-search-box', SearchBox),
        new VueComponentInitializer(
            '.vue-line-chart',
            LineChartControl,
            () => ({
                propsData: {
                    language: navigator.language,
                },
            }),
        ),
        new VueComponentInitializer('.vue-price-map', PriceMap, element => {
            return {
                i18n: translationsFromAttribute(element, 'data-translations'),
            };
        }),
    ].forEach(initializer => initializer.initialize(snippet));
});

document.addEventListener('DOMContentLoaded', () => {
    // Prevents NS_ERROR_ILLEGAL_VALUE on large pages in Firefox
    naja.historyHandler.historyAdapter = {
        replaceState: () => {},
        pushState: () => {},
    };

    naja.initialize({history: false, timeout: 120000});
});

(window as any).Chart = Chart;
